import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const setFlowCompleted = async <T extends Action<ACTION_TYPE.SET_FLOW_COMPLETED>>({ uniqueId }: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId
      },
      type: ACTION_TYPE.SET_FLOW_COMPLETED
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const user = body.data

    return user
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.SET_FLOW_COMPLETED, {
      uniqueId
    })
    throw err
  }
}

export const getPhysicianCountries = async <T extends Action<ACTION_TYPE.GET_PHYSICIAN_COUNTRIES>>(): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {},
      type: ACTION_TYPE.GET_PHYSICIAN_COUNTRIES
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const countries = body.data

    return countries
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_PHYSICIAN_COUNTRIES)
    throw err
  }
}
